import React, { useState } from 'react';
import { Button, CloseButton, Dialog, Portal } from '@chakra-ui/react';
import theme from '../theme';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import updatePacketDate from '../lib/updatePacketDate';
import moment from 'moment';

export default ({ currentPacket, setCalendar, phaseKey, setPacketList }) => {
	const [error, setError] = useState('');
	const [startDate, setStartDate] = useState(new Date());

	const changeDateRef = React.useRef();

	const handleDateChange = async date => {
		setStartDate(date);

		date = moment(date);

		const formattedDate = date.format('MM-DD-YY');
		let title = currentPacket.title.split('_');
		title.splice(1, 1, formattedDate);
		title = title.join('_');

		await updatePacketDate(currentPacket.packet_id, title, phaseKey, date.unix())
			.then(() => {
				setPacketList(prevPacketList =>
					prevPacketList.map(packet =>
						packet.packet_id === currentPacket.packet_id
							? {
									...packet,
									title
								}
							: packet
					)
				);
				setCalendar(false);
			})
			.catch(error => setError(error.message));
	};

	return (
		<>
			<DatePicker selected={startDate} onChange={handleDateChange} inline />
			<Dialog.Root
				role="alertdialog"
				initialFocusEl={changeDateRef}
				onOpenChange={({ open }) => {
					if (!open) {
						setCalendar(false);
					}
				}}
				open={Boolean(error)}
				placement="center"
			>
				<Portal>
					<Dialog.Backdrop />
					<Dialog.Positioner>
						<Dialog.Content opacity="1 !important">
							<Dialog.Header>
								<Dialog.Title fontSize="lg" fontWeight="bold">
									Failed to Change Packet Date
								</Dialog.Title>
							</Dialog.Header>
							<Dialog.Body>
								<p>
									We encountered an error attempting to update the packet date. Please try again
									later. {error}
								</p>
							</Dialog.Body>
							<Dialog.Footer>
								<Dialog.ActionTrigger asChild>
									<Button ref={changeDateRef} onClick={() => setCalendar(false)}>
										Close
									</Button>
								</Dialog.ActionTrigger>
								<Button
									colorPalette="red"
									ml={3}
									bg={theme.colors.red[500]}
									color={theme.colors.white}
									onClick={() => setCalendar(false)}
								>
									Ok
								</Button>
							</Dialog.Footer>
							<Dialog.CloseTrigger asChild>
								<CloseButton size="sm" />
							</Dialog.CloseTrigger>
						</Dialog.Content>
					</Dialog.Positioner>
				</Portal>
			</Dialog.Root>
		</>
	);
};
